rjm.ui.ChartBuilderPreviewView = rjm.ui.ChartBuilderBlockableView.extend(
  initialize: (options) ->
    if not options or not options.chartModel or not options.viewState
      throw "InvalidConstructorArgs - ChartBuilderPreviewView"

    _.bindAll this, "render", "generateTemplateData", "rebindEvents"
    @model = options.chartModel
    @viewState = options.viewState
    @ajaxPromise = null
    @queueAjax = false

    @listenTo @model, "change:api_conn_id", @block
    @listenTo @model.getCurrentSeries(), "change:trend", @unblock
    return

  rebindEvents: ->
    oldClosure = rjm.util.deferredClosureQueue.getClosure(rjm.util.deferredClosureQueueOrder.CHART_PREVIEW)
    newClosure = rjm.util.deferredClosureQueue.setAndReturnClosure(
      closure: @render
      queuePosition: rjm.util.deferredClosureQueueOrder.CHART_PREVIEW
      predicate: (args) =>
        model = args[0]
        eventParams = args[1]

        if eventParams?.hasOwnProperty("force") and eventParams?.force
          return true

        #This is here to address an issue where backbone relational would trigger a "create: true" change event right before an actual change
        #This was breaking highcharts when using the chart builder to load a GA chart for a second time from the dashapp
        if eventParams?.hasOwnProperty("create") and eventParams?.create
          return false

        #HACK - most collections in NCB are relational and do not fire events the preview listens for. however normal collections do
        #this is here to stop the preview frame from rendering everytime a collection fires an add/remove/reset event as well as
        #handeling collections because they do not have a changedAttributes method.
        if model.isCollection
          return false

        #not a collection so just get the changed attributes
        newAttrs = model.changedAttributes()
        #don't re-render if the name, api connedction id or trend's minTime attribute changed
        if _(newAttrs).isObject() and
            (newAttrs.hasOwnProperty("name") or
            newAttrs.hasOwnProperty("api_conn_id")) or
            newAttrs.hasOwnProperty("minTime")
          return false
        # don't re-render if the restriction sequence is invalid
        else if _(@viewState.get("chartValidationErrors").restrictionSequence).isString()
          return false
        true
    )
    @model.bindEventToChildren
      unbindFirst: true
      previouslyBoundFunction: oldClosure #HACK -- assumes same function for all events
      modelEvents:
        change: newClosure

      collectionEvents:
        add: newClosure
        remove: newClosure
        reset: newClosure
    return


  generateTemplateData: ->
    $.ajax
      type: "POST"
      url: $.url("/client/" + @model.get('clientId') + "/chart/preview/")
      data:
        chartModel: JSON.stringify(@model.toJSON())

  render: ->
    @rebindEvents()
    if _(@ajaxPromise).isNull() or @ajaxPromise.state() isnt "pending"
      @ajaxPromise = @generateTemplateData()

      if @viewState.get("isSaving")
        return

      #we dont want to show the loading message if we are saving
      unless @viewState.get("isSaving")
        $(@el).addClass('blocked loading')

      $.when(@ajaxPromise).done(_.bind((html) ->
        $(@el).html ich.chartBuilderPreview(html: html)
      , this)).fail(_.bind((jqXHR, message) ->
        unless message is "abort"
          $(@el).html "Invalid Chart - Contact Support"
          $(@el).removeClass('blocked loading')
      , this)).then _.bind(->
        if @queueAjax
          @queueAjax = false
          @render()
        else
          $(@el).removeClass('blocked loading')
      , this)
    else
      @queueAjax = true
    return
)
